

import React, { Component } from 'react';

class PreviewInvoice extends Component {
    getStyles(id, user){
        let palette = user.styles.colorPalette ||  {
            color1:'#808080',
            color2:'#68bc00',
            color3:'#68bc00',
            color4:'#ffffff',
            color5:'#653294',
          }
       
        return `
        #${id} {
            padding: 20px;
            font-family: Arial;
            font-size: 10px;
            color: ${palette.color1}
        }
       
        #${id} > table td h1,
        #${id} > table td h3 {
            margin: 0px;
            color: ${palette.color2};
        }
   
        #${id} > hr {
            border: 1px solid ${palette.color2};
            margin: 30px 0;
        }
   
        #${id} > table.bordered {
            border-collapse: collapse;
        }
   
        #${id} > table.bordered td,
        #${id} > table.bordered th,
        #${id} > table.bordered {
            border: 1px solid ${palette.color3};
            border-left: none;
            border-right: none;
            border-bottom: none;
        }
   
        #${id} > .border-color{
           border: 1px solid ${palette.color3} !important;
        }
   
        #${id} > .full-width { width: 100%; }
   
        #${id} > .text-center { text-align: center; }
        #${id} > .text-right { text-align: right; }
        #${id} > .text-left { text-align: left; }
        #${id} > .text-top * { vertical-align: top; }
   
        #${id} > table.padded th,
        table.padded td {
            padding: 5px;
            vertical-align: top;
        }
   
        #${id} > table th {
            font-weight: normal;
        }
   
        #${id} > table > .header,
        #${id} > table > .header>tr>th
        {
           background-color: ${palette.color4};
           color: ${palette.color5};
        }
   
        #${id} > table .mt-s { margin-top: 15px; }
        #${id} > table  .mb-s { margin-bottom: 15px; }
   
        #${id} > table > tbody > tr > .no-border{
            border-top:none !important;
            border-bottom: none !important;
        }
   
        #${id} > table > tbody > tr > td > .total{
            color: ${palette.color3};
        }
   
        #${id} > .legal-text{
           text-align: justify;
        }
   
        `
    }

    render() {
        let { seller, id, zoom } = this.props;
        if( !seller || !seller.styles || !id){
            return <div>Preview not avaiable, you need to choose a location first.</div>
        }
        return (<div>
            <style dangerouslySetInnerHTML={{__html: this.getStyles("B" + id, seller)}}>

            </style>
            <div className="" id={"B" + id} style={{ fontFamily:'Nunito', backgroundColor: 'white', overflow:'hidden', zoom:zoom || 1}}>
                <table className="full-width padded mt-s mb-s">
                    <tbody>
                        <tr>
                            <td style={{textAlign:'left', width: "35%"}}>

                                <p>Seller: Seller Inc.</p>
                                <p>Registration Number.: F05&#x2F;XX&#x2F;YYYY</p>
                                <p>Tax ID: 00000000</p>

                                <p>Address: The Street Name Str. New York</p>
                                <p>Region: New York</p>
                                <p>Zip: 000000</p>
                                <p>Country:  USA</p>

                                <p>Phone: 202-555-0131</p>
                                <p>Email: contact@seller.co</p>
                                <p>Website: example.com</p>
                                <p>Bank: Some Bank Name</p>
                                <p>IBAN USD: xxxxx-xxxxxxx-xxxxxx-xxxxx</p>
                            </td>
                            <td style={{textAlign:'left', width: "35%"}}>

                                <p>Company: GC</p>
                                <p>Contact: JOE DOW</p>
                                <p>Address: Brodway 345, New York</p>
                                <p>Region: New York</p>
                                <p>Zip: 1221211</p>
                                <p>Country:  USA</p>
                                <p>Phone: 202-555-0131</p>
                                <p>Email: joe@customers.com</p>
                            </td>
                            <td style={{fontFamily:'Nunito', textAlign: "center", width: "30%"}}>

                                <h3 style={{fontFamily:'Nunito', textAlign: "center"}}>INVOICE</h3>
                                <br />
                                <table style={{fontFamily:'Nunito', padding:"5px", width:"100%"}}>
                                    <tbody>
                                        <tr>
                                            <td style={{textAlign: "center"}}>Serie GC nr. 1<br />
                                                Invoice Date (dd/mm/yyyy): 08&#x2F;10&#x2F;18
                                        </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <br />
                                <img src={seller.styles.logo} width="200px" />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <table style={{fontFamily:'Nunito'}} className="bordered full-width padded mt-s mb-s">
                    <thead className="header">
                        <tr>
                            <th style={{width: "30px"}}><strong>#</strong></th>
                            <th>
                                <strong>Product</strong>
                            </th>
                            <th>
                                <strong>Qty.</strong><br />
                            </th>
                            <th>
                                <strong>Unit<br />
                                    –USD–
                                    </strong>

                            </th>

                            <th>
                                <strong>Price<br />
                                    –USD–
                            </strong>
                            </th>


                            <th>
                                <strong>VAT Price<br />
                                    –USD–
                            </strong>
                            </th>
                            <th>
                                <strong>VAT Rate</strong>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="text-top">
                        <tr>
                            <td className="no-border" style={{textAlign:"center"}}>1</td>
                            <td className="no-border">Advanced Fantastic Frozen Pants - Fresh cyan</td>
                            <td className="no-border" style={{textAlign:"center"}}>2</td>
                            <td className="text-right no-border">190.83</td>
                            <td className="text-right no-border">381.66</td>
                            <td className="text-right no-border">34.35</td>
                            <td className="text-right no-border">9%</td>
                        </tr>
                        <tr>
                            <td className="no-border" style={{textAlign:"center"}}>2</td>
                            <td className="no-border">Discount</td>
                            <td className="no-border" style={{textAlign:"center"}}>1</td>
                            <td className="text-right no-border">-27.56</td>
                            <td className="text-right no-border">-27.56</td>
                            <td className="text-right no-border">-2.48</td>
                            <td className="text-right no-border">9%</td>
                        </tr>
                        <tr>
                            <td className="no-border" style={{textAlign:"center"}}>3</td>
                            <td className="no-border">Ameliorated User-friendly Unbranded Concrete Table</td>
                            <td className="no-border" style={{textAlign:"center"}}>3</td>
                            <td className="text-right no-border">42.20</td>
                            <td className="text-right no-border">126.60</td>
                            <td className="text-right no-border">11.39</td>
                            <td className="text-right no-border">9%</td>
                        </tr>
                        <tr>
                            <td className="no-border" style={{textAlign:"center"}}>4</td>
                            <td className="no-border">Discount</td>
                            <td className="no-border" style={{textAlign:"center"}}>1</td>
                            <td className="text-right no-border">-9.14</td>
                            <td className="text-right no-border">-9.14</td>
                            <td className="text-right no-border">-0.82</td>
                            <td className="text-right no-border">9%</td>
                        </tr>
                        <tr>
                            <td className="no-border" style={{textAlign:"center"}}>5</td>
                            <td className="no-border">Transport</td>
                            <td className="no-border" style={{textAlign:"center"}}>1</td>
                            <td className="text-right no-border">4.20</td>
                            <td className="text-right no-border">4.20</td>
                            <td className="text-right no-border">0.8</td>
                            <td className="text-right no-border">19%</td>
                        </tr>

                        <tr>
                            <td colSpan="4" className="text-right">
                                <strong>Total (–USD–) </strong><br />
                            </td>
                            <td className="text-right">
                                <strong>475.76</strong>
                            </td>
                            <td className="text-right">
                                <strong>43.24</strong>
                            </td>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan="8" className="text-right">
                                <strong className="total">INVOICE TOTAL: 519.00 USD </strong><br />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
            <div className="legal-text">{seller.styles.thankYouText}</div>
            </div>
           
        </div>)
    }
}


export default PreviewInvoice;


// WEBPACK FOOTER //
// app/components/PreviewInvoice.jsx